import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar-footer',
  standalone: true,
  imports: [CommonModule],
  // L'identité est dans l'avatar de la barre du haut (30/10/2026) : ici, seulement la déconnexion.
  template: `
    <div class="sidebar-footer" [class.collapsed]="collapsed">
      <button type="button" class="footer-logout" (click)="logout.emit()" [attr.title]="collapsed ? 'Déconnexion' : null">
        <span class="logout-icon">→</span>
        @if (!collapsed) {
          <span class="logout-text">Déconnexion</span>
        }
      </button>
    </div>
  `,
  styleUrl: './sidebar-footer.component.scss'
})
export class SidebarFooterComponent {
  @Input() collapsed = false;
  @Output() logout = new EventEmitter<void>();
}
